<template>
  <div id="record">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toUrl()">
        <van-icon name="arrow-left" size="20" />
      </div>
      <div class="center">{{category}}</div>
      <div class="right" @click="toHome()" >
        <van-icon name="wap-home" size="21"/>
      </div>
    </div>
    <div class="padding content">
      <van-field v-model="unit_name" required clearable label="单位名称" placeholder="请输入单位名称" />
      <van-field v-model="position" required clearable label="招聘岗位" placeholder="请输入招聘岗位" />
      <van-field v-model="recruit_number" type="digit" required clearable label="招聘人数" placeholder="请输入招聘人数" />
      <van-field v-model="salary" required clearable label="薪资待遇" placeholder="请输入薪资待遇" />
      <van-field v-model="work_time" required clearable label="工作时间" placeholder="请输入工作时间" />
      <van-field name="radio" label="是否缴纳社保" required>
        <template #input>
          <van-radio-group v-model="radio" direction="horizontal">
            <van-radio name="1" checked-color="#6DCC13">是</van-radio>
            <van-radio name="2" checked-color="#6DCC13">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field v-model="contacts_name" required clearable label="联系人姓名" placeholder="请输入联系人姓名" />
      <van-field
       clearable
        v-model="contacts_telphone"
        required
        type="tel"
        label="联系人电话"
        placeholder="请输入联系人电话"
      />
      <van-field v-model="category" required label="工作类型" readonly />
      <div class="comfirm-btn" @click="toSubmit()">提交</div>
    </div>
    <van-dialog v-model="show" title="提示" show-cancel-button :beforeClose="beforeClose">
      <div style="margin:1.5rem 0">确定要提交吗？</div>
    </van-dialog>
  </div>
</template>
<script>
import { Icon, Field, RadioGroup, Radio, Toast, Dialog } from "vant";
import { helpJob } from "@/api/apiData";
import { formatDate } from "@/public/getFormatDate.js";
export default {
  components: {
    [Icon.name]: Icon,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      info: [],
      type: "",
      unit_name: "",
      position: "",
      contacts_name: "",
      contacts_telphone: "",
      category: "",
      recruit_number: "",
      salary: "",
      work_time: "",
      radio: "1",
      has_social_security: "",
      show: false,
    };
  },
  filters: {
    //方法一: yyyy-MM-dd hh:mm
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      console.log(date);
      return formatDate(date, "yyyy-MM-dd hh:mm");
    },
  },
  mounted() {
    let type = this.$route.query.type;
    this.type = type;
    if (type == 1) {
      this.category = "公益性岗位";
    } else if (type == 2) {
      this.category = "按比例安置";
    } else if (type == 3) {
      this.category = "集中安置";
    }
  },
  methods: {
    toUrl() {
      this.$router.go(-1);
    },
    toHome() {
      window.location.href="http://ncymkj.doudou00.com/index.php?g=Wap&m=Index&a=lists&token=hmatos1596436588&classid=20403"
      // this.$router.push("/index");
    },
    toSubmit() {
      if (this.unit_name == "") {
        Toast("请输入单位名称");
      } else if (this.position == "") {
        Toast("请输入招聘岗位");
      } else if (this.recruit_number == "") {
        Toast("请输入招聘人数");
      } else if (this.salary == "") {
        Toast("请输入薪资待遇");
      } else if (this.work_time == "") {
        Toast("请输入工作时间");
      } else if (this.contacts_name == "") {
        Toast("请输入联系人姓名");
      } else if (!/^1[34578]\d{9}$/.test(this.contacts_telphone)) {
        Toast("请输入正确电话号码");
      } else {
        this.show = true;
      }
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        if (this.radio == 1) {
          this.has_social_security = "是";
        } else {
          this.has_social_security = "否";
        }
        var parm = {
          unit_name: this.unit_name,
          position: this.position,
          recruit_number: this.recruit_number,
          salary: this.salary,
          work_time: this.work_time,
          has_social_security: this.has_social_security,
          contacts_name: this.contacts_name,
          contacts_telphone: this.contacts_telphone,
          category: this.category,
        };

        helpJob(parm).then((res) => {
          Toast(res.message);
          if (res.status == 1) {
            this.$router.push({
              path: "/successful",
              query: {
                type: 1,
              },
            });
          }
        });
      } else {
        done();
      }
    },
  },
};
</script>
<style scoped>
.info-tit {
  font-weight: bold;
}
.content {
  width: 90%;
  margin: 0 auto;
  /* padding-top: 1rem; */
  /* margin-top: 10%; */
  text-align: left;
}
.info-tit {
  font-weight: bold;
  font-size: 1.2rem;
  margin: 1rem 0;
}
.info-time {
  font-size: 0.9rem;
  color: gray;
}
.info-time span {
  color: #72b550;
  margin-right: 1rem;
}
.infos {
  font-size: 1rem;
  text-indent: 2rem;
}
.info-img {
  text-align: center;
  margin: 1rem 0;
}
.info-img img {
  width: 80%;
  margin: 0 auto;
}
.list {
  border-bottom: solid 1px gainsboro;
  color: gray;
  padding: 1rem 0;
}
.comfirm-btn {
  width: 95%;
  margin: 0 auto;
  background: #6dcc13;
  height: 2.5rem;
  line-height: 2.5rem;
  color: white;
  text-align: center;
  margin-top: 2rem;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/page/helpForm.vue